import "@fiveway/core";
import { defaultKeybinds, registerKeyboardListener } from "@fiveway/core/dom";
import { createContext, useContext, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/context.tsx
/**
* React context for navigation
*
* @see {@link useNavigationContext}
* @see {@link NavigationRoot}
*/
const NavigationContext = createContext(null);
/**
* Hook that reads {@link NavigationContext}.
*/
function useNavigationContext() {
	const navContext = useContext(NavigationContext);
	if (navContext == null) throw new Error("expected navigation context");
	return navContext;
}
/**
* React component that provides navigation context and attaches keyboard listeners for dispatching navigation actions.
*
* By default listeners are attached to `window` and use {@link defaultKeybinds} to map events to navigation actions.
*
* @see {@link NavigationRootProps} for configuration options
*
* @example
* ```tsx
* const tree = createNavigationTree();
*
* <NavigationRoot tree={tree}>
* 	<App />
* </NavigationRoot>
* ```
*/
function NavigationRoot(props) {
	useEffect(() => {
		if (props.listener === null) return;
		return registerKeyboardListener(props.tree, props.listener ?? window, props.keybinds ?? defaultKeybinds);
	}, [
		props.tree,
		props.listener,
		props.keybinds
	]);
	return /* @__PURE__ */ jsx(NavigationContext.Provider, {
		value: {
			tree: props.tree,
			parentNode: "#"
		},
		children: props.children
	});
}
//#endregion
export { NavigationContext, NavigationRoot, useNavigationContext };

//# sourceMappingURL=context.js.map